var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.66 11.366c1.786 1.288 1.786 3.98 0 5.268l-.364.264a79.314 79.314 0 0 1-12.997 7.617l-.407.189c-1.993.925-4.289-.42-4.495-2.634l-.043-.453a82.018 82.018 0 0 1 0-15.234l.043-.453c.206-2.214 2.502-3.56 4.495-2.634l.407.19a79.317 79.317 0 0 1 12.997 7.616l.365.264Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay28);
export default __webpack_public_path__ + "static/media/play_28.37b209a6.svg";
export { ForwardRef as ReactComponent };